var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHexColor)?_c('div',{staticClass:"custom-icon",style:(_vm.hexStyle),attrs:{"title":_vm.name}}):_c('img',{staticClass:"custom-icon",style:(_vm.iconStyle),attrs:{"src":_vm.iconSrc,"alt":_vm.name,"width":_vm.size,"height":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }